const communityAbs = 'CMA';

let gAdsValue = typeof gads !== "undefined" ? gads : true;
if(gAdsValue === true) {
  const REQUEST_URL = 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js';

  const REQUEST_CONFIG = {
      method: 'HEAD',
      mode: 'no-cors'
  };

  const checkAdsBlocked = (callback) => {
    fetch(REQUEST_URL, REQUEST_CONFIG)
      .then((response) => {
          callback(response.redirected);  // ads are blocked if request is redirected
      })                                  // (we assume the REQUEST_URL doesn't use redirections)
      .catch(() => {
          callback(true);                 // ads are blocked if request fails
      });                                 // (we do not consider connction problems)
  };

  checkAdsBlocked((adsBlocked) => {
    if(adsBlocked){
      getBlockAds();
    } else {
      fetchAd();
    }
  });
}

async function getBlockAds() {
  await fetch(`https://middleware.pmmalliance.com/airtable-retrieve-custom-table?attr=Grid%20view&view=${communityAbs}&base=appmEWAUnRlSWtQP2`)
    .then(response => response.json())
    .then(response => {
      renderAds(response);
    })
    .catch(err => console.error(err));
}

function renderAds(ads) {
  const adsDisplay = {
      top: [],
      right: [],
      bottom: [],
  };
  // Get the current URL
  const currentUrl = window.location.href;
  let memberType = "";
  if(viewerType == "outsider") {
    memberType = "Outsider";
  } else if(viewerType == "insider") {
    memberType = "Insider";
  } else if(viewerType == "pro") {
    memberType = "Pro";
  } else if(viewerType == "pro-plus") {
    memberType = "Pro+";
  } else if(viewerType == "exec-plus") {
    memberType = "Exec+";
  }
  
  if(ads) {
    ads.forEach((ad) => {
      if(ad.fields && ad.fields['Status'] == "Active") {
        if(ad.fields['Tag'] && ad.fields['Tag'].length > 0) {
          const isPresent = ad.fields['Tag'].some(item => allTag.includes(item));
          if(isPresent) {
            if(ad.fields['Tier type'] && ad.fields['Tier type'].length > 0) {
              const isTierTypePresent = ad.fields['Tier type'].includes(memberType);
              if(isTierTypePresent) {
                adsDisplay[ad.fields['Position'].toLowerCase()].push(ad);
              }
            } else {
              adsDisplay[ad.fields['Position'].toLowerCase()].push(ad);
            }
          }
        } else {
          if(ad.fields['Tier type'] && ad.fields['Tier type'].length > 0) {
            const isTierTypePresent = ad.fields['Tier type'].includes(memberType);
            if(isTierTypePresent) {
              adsDisplay[ad.fields['Position'].toLowerCase()].push(ad);
            }
          } else {
            adsDisplay[ad.fields['Position'].toLowerCase()].push(ad);
          }
        }
      }
    });
  }

  // Function to get a random item from an array
  function getRandomItem(array) {
      const randomIndex = Math.floor(Math.random() * array.length);
      return array[randomIndex];
  }

  // Get a random item from each array
  const randomTopAd = getRandomItem(adsDisplay.top);
  const randomRightAd = getRandomItem(adsDisplay.right);
  const randomBottomAd = getRandomItem(adsDisplay.bottom);

  // Function to create an img element with a link for an ad
  function createImgLinkElement(ad) {
      const linkElement = document.createElement("a");
      linkElement.setAttribute("target", "_blank");
      linkElement.href = ad.fields['Link'];

      const imgElement = document.createElement("img");
      if(screenWidth <= 500){
        imgElement.src = ad.fields["Mobile image"]?.[ad.fields["Mobile image"].length - 1].url || "";
      }else{
        imgElement.src = ad.fields["Desktop image"]?.[ad.fields["Desktop image"].length - 1].url || "";
      }
      
      imgElement.alt = ad.fields['Name'];

      linkElement.appendChild(imgElement);
      return linkElement;
  }

  // Function to append ad to container and display it
  function displayAd(ad, container) {
      if (!container) {
        console.error(`Element not found.`);
        return;
      }
      if (ad) {
          const adImgElement = createImgLinkElement(ad);
          if(container){
            container.appendChild(adImgElement);
            container.style.display = "block";
          }
          setTimeout(() => {
            generateMediaPackLink(container, true);  
          }, 1000);
      }
  }

  // Get the container elements by their IDs
  const topAdsContainer = document.getElementById("topContainer");
  const rightAdsContainer = document.getElementById("rightAdsContainer");
  const bottomAdsContainer = document.getElementById("bottomAdsContainer");

  // Create img elements for each random ad and append them to their respective containers
  displayAd(randomTopAd, topAdsContainer);
  displayAd(randomRightAd, rightAdsContainer);
  displayAd(randomBottomAd, bottomAdsContainer);
  
}

async function fetchAd() {

  let internalTags = [];
  let sponsoredTags = [];
  let foundTags = [];

  let currentViewerType = viewerType;
  if(viewerType == "Exec+") {
    currentViewerType = "exec-plus";
  }

  if(viewerType == "Pro+") {
    currentViewerType = "pro-plus";
  }
  
  internalTags = internalTagInhouse.map(item => `${item}-${currentViewerType.toLowerCase()}`);
  sponsoredTags = internalTagSponsor.map(item => `${item}-${currentViewerType.toLowerCase()}`);
  const mergeTags = [...internalTags, ...sponsoredTags, `global-${currentViewerType.toLowerCase()}`].filter(tag => tag !== undefined);
  console.log("mergeTags", mergeTags.join(","));
  try {
    const response = await fetch(`https://middleware-v2.pmmalliance.com/ad-manager/ads?community=${communityAbs}&sponsored=false&tags=${mergeTags.join(",")}`);
    const data = await response.json();
    
    foundTags = data.data;
    // if(foundTags.length === 0) {
    foundTags.push('global');
    // }
    
    const SlotId = await generateRandomAdSlotId();
    const SlotIdTop = await generateRandomAdSlotId();
    const SlotIdMobileTop = await generateRandomAdSlotId();
    const SlotIdSide = await generateRandomAdSlotId();
    const SlotIdBottom = await generateRandomAdSlotId();
    const SlotIdMobileBottom = await generateRandomAdSlotId();

    await setupAdManager(SlotIdTop, SlotIdMobileTop, SlotIdBottom, SlotIdMobileBottom, SlotIdSide, foundTags);

    createAdContainer(SlotIdTop, 'topContainer');
    createAdContainer(SlotIdMobileTop, 'topContainer');
    createAdContainer(SlotIdBottom, 'bottomAdsContainer');
    createAdContainer(SlotIdMobileBottom, 'bottomAdsContainer');
    createAdContainer(SlotIdSide, 'rightAdsContainer');
    
    const mergeSlotId = [SlotIdTop, SlotIdMobileTop, SlotIdBottom, SlotIdMobileBottom, SlotIdSide];

    setTimeout(() => {
      generateMediaPackLink(mergeSlotId, false);  
    }, 2000);
  } catch (err) {
    console.error('Error:', err);
  }
}

function generateMediaPackLink(slotIds, block) {
  if(!block) {
    slotIds.forEach((id) => {
      const adElem = document.getElementById(id);

      if (adElem && window.getComputedStyle(adElem).display !== 'none') {
        // Create a new element to add after adElem
        const newElem = document.createElement('a');
        newElem.classList.add("media-pack");
        newElem.setAttribute("target", "_blank");
        newElem.setAttribute("href", "https://www.productmarketingalliance.com/media-pack/?filter=digital---advertising");
        newElem.textContent = 'Advertise with us';
  
        // Insert after adElem
        adElem.insertAdjacentElement('afterend', newElem);
      }
    })
    
  } else {
    const aElem = slotIds.querySelector("a");
    
    const newElem = document.createElement('a');
    newElem.classList.add("media-pack");
    // newElem.setAttribute("target", "_blank");
    newElem.setAttribute("href", "https://www.productmarketingalliance.com/media-pack/?filter=digital---advertising");
    newElem.textContent = 'Advertise with us';

    // Insert after adElem
    aElem.insertAdjacentElement('afterend', newElem);
  }
  
  
}

async function setupAdManager(SlotIdTop, SlotIdMobileTop, SlotIdBottom, SlotIdMobileBottom, SlotIdSide, foundTags) {
  window.googletag = window.googletag || {cmd: []};
  googletag.cmd.push(function() {
    googletag.defineSlot(`/23035269294/${communityAbs}-Sponsor-and-Inhouse/top-banner`, [728, 90], `${SlotIdTop}`).addService(googletag.pubads());
    googletag.defineSlot(`/23035269294/${communityAbs}-Sponsor-and-Inhouse/mobile-top`, [300, 100], `${SlotIdMobileTop}`).addService(googletag.pubads());
    googletag.defineSlot(`/23035269294/${communityAbs}-Sponsor-and-Inhouse/side-banner`, [240, 400], `${SlotIdSide}`).addService(googletag.pubads());
    googletag.defineSlot(`/23035269294/${communityAbs}-Sponsor-and-Inhouse/bottom-banner`, [580, 400], `${SlotIdBottom}`).addService(googletag.pubads());
    googletag.defineSlot(`/23035269294/${communityAbs}-Sponsor-and-Inhouse/mobile-bottom`, [240, 400], `${SlotIdMobileBottom}`).addService(googletag.pubads());
    googletag.pubads().enableSingleRequest();
    googletag.pubads().collapseEmptyDivs();
    googletag.pubads().setTargeting(`${communityAbs}-Sponsor-Clients`, foundTags).setTargeting(`${communityAbs}-In-house`, foundTags);
    googletag.enableServices();
  });
}

async function createAdContainer(SlotId, DivElement) {
  // Find the target element
  const topContainer = document.getElementById(DivElement);
  if (!topContainer) {
    console.error(`Element with ID ${DivElement} not found.`);
    return;
  }

  // Create the ad div
  const adDiv = document.createElement("div");
  adDiv.id = `${SlotId}`;

  // Create the script tag inside the div
  const adScript = document.createElement("script");
  adScript.textContent = `googletag.cmd.push(function() { googletag.display('${SlotId}'); });`;

  // Append elements
  adDiv.appendChild(adScript);
  topContainer.appendChild(adDiv);
}

async function generateRandomAdSlotId() {
  const timestamp = Date.now();
  const randomPart = Math.floor(Math.random() * 10000); // Random 4-digit number
  return `div-gpt-ad-${timestamp}${randomPart}-0`;
}